export default __webpack_public_path__ + "media/images/svg/graphic-bg-1-02ba69cb1c91f38dcea5b67ddf24b70a.svg";